/**
 * Project column column_name mappings
 * Contains headerName and column_name definitions for project grid columns
 * @param {Function} t - Translation function
 * @returns {Array} Array of column column_name mappings with headerName and column_name only
 */
export const getProjectColumnFields = (t) => {
  return [
    // { 
    //   headerName: 'project_id', 
    //   column_name: 'project_id',
    //   is_visible: false,
    //   column_order: 1
    // },
    {
      headerName: t('Internal Project Name'), 
      column_name: 'project_name',
      is_visible: true,
      column_order: 1
    },
    {
      headerName: t('Project Number'), 
      column_name: 'project_number',
      is_visible: true,
      column_order: 2
    },
    // {
    //   headerName: t('Workspace ID'), 
    //   column_name: 'project_ws_id',
    //   is_visible: false,
    //   column_order: 4
    // },
    {
      headerName: t('Copy'), 
      column_name: 'Copy',
      is_visible: true,
      column_order: 3
    },
    {
      headerName: t('Fav'), 
      column_name: 'favorite',
      is_visible: true,
      column_order: 4
    },
    { 
      headerName: t('Status'), 
      column_name: 'project_status_desc',
      is_visible: true,
      column_order: 5
    },
    { 
      headerName: t('Lead Project Manager'), 
      column_name: 'lead_project_manager',
      is_visible: true,
      column_order: 6
    },
    { 
      headerName: t('Lead Project Engineer'), 
      column_name: 'lead_project_engineer',
      is_visible: true,
      column_order: 7
    },
    { 
      headerName: t('Created By'), 
      column_name: 'created_by',
      is_visible: true,
      column_order: 8
    },
    { 
      headerName: t('Created Date'), 
      column_name: 'start_date',
      is_visible: true,
      column_order: 9
    },
    { 
      headerName: t('Last Modified Date'), 
      column_name: 'last_mod_date',
      is_visible: true,
      column_order: 10
    },
    { 
      headerName: t('Project Data Link Project Name'), 
      column_name: 'pdl_project_name',
      is_visible: true,
      column_order: 11
    },
  ];
};
